import React from 'react'
import { connect } from 'react-redux'
import './SurveySearch.scss'
import { LuxSelect } from '@lux/wardrobe-lib'
import { useIntl } from 'react-intl'
import { NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE } from '@/app/redux/reducers/activity-creation'

const SurveySearch = (props) => {
    const componentClass = 'smart-new-activity-action-survey-search'
    const intl = useIntl()
    const {
        form,
        bannerOptions,
        regionOptions,
        countryOptions,
        onSetBanner,
        onSetCountry,
        onSetRegion,
        disabled,
    } = props

    return (
        <div className={`${componentClass}`}>
            <LuxSelect
                value={form.banner.length === 1 ? form.banner[0] : form.banner}
                disabled={disabled}
                onChangeCallback={(e) => onSetBanner([e])}
                options={bannerOptions}
                label={intl.formatMessage({
                    id: 'modals.new.activity.section.action.survey.search',
                    defaultMessage: 'Search survey',
                })}
                placeholder={intl.formatMessage({
                    id: 'modals.new.activity.section.action.survey.search.banner',
                    defaultMessage: 'Select banner',
                })}
                additionalProps={{
                    appendTo: 'self',
                }}
            />
            <LuxSelect
                value={form.country.length === 1 ? form.country[0] : form.country}
                disabled={disabled}
                onChangeCallback={(e) => onSetCountry([e])}
                options={countryOptions}
                placeholder={intl.formatMessage({
                    id: 'modals.new.activity.section.action.survey.search.country',
                    defaultMessage: 'Select country',
                })}
                additionalProps={{
                    appendTo: 'self',
                }}
            />
            {/* <LuxSelect
                value={form.region}
                disabled={disabled}
                onChangeCallback={onSetRegion}
                options={regionOptions}
                placeholder={intl.formatMessage({
                    id: 'modals.new.activity.section.action.survey.search.region',
                    defaultMessage: 'Select region',
                })}
                additionalProps={{
                    appendTo: 'self',
                }}
            /> */}
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    bannerOptions: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].banner,
    regionOptions: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].region,
    countryOptions: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].country,
})

const mapDispatchToProps = (dispatch: any) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(SurveySearch)
